export enum PeriodizationType {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}
